<template>
  <div class="line-height-lg">
    <div @click="openImgPopup">
      <div :class="[
                'border-radius border pt-0 px-3 py-3',
                { 'bgray-100': background_color === '#FFFFFF00' }
              ]" 
              :style="background_color !== '#FFFFFF00' ? `background-color: ${background_color}` : ''">
        <div v-if="business_case_obj?.badge_text != '' || show_title" class="d-flex align-items-center border-radius mb-3" >
          <div v-if="business_case_obj?.badge_text != ''" class="fw-600 mr-3 business-case-badge" :style="`background-color: ${mainColor}`">
            {{ lang != 'ENG' ? business_case_obj?.badge_text: business_case_obj?.translated?.badge_text_e || business_case_obj?.badge_text }} 
          </div>

          <h5 v-if="show_title" class="fw-600 gray-800 mb-0">
            {{ lang != 'ENG' ? business_case_obj.title : business_case_obj?.translated?.title_e }}
          </h5>
        </div>

        <template v-if="lang != 'ENG'">
          <HtmlText :content="business_case_obj.description"></HtmlText>
          <div v-if="business_case_id != '' && business_case_obj.files.length > 0" class="f-95 gray-600 mb-45">
            첨부파일 :
            <span v-for="item in business_case_obj.files" :key="item.id" class="mr-3">
              <a :href="$store.state.static_host + item.file_path" target="_blank">{{
                item.file_name
              }}</a>
            </span>
          </div>
        </template>

        <template v-else>
          <HtmlText :content="business_case_obj?.translated?.description_e"></HtmlText>
          <div v-if="business_case_id != '' && business_case_obj?.translated?.files.length > 0"
            class="f-95 gray-600 mb-45">
            Attatched File :
            <span v-for="item in business_case_obj?.translated?.files" :key="item.id" class="mr-3">
              <a :href="$store.state.static_host + item.file_path" target="_blank">{{
                item.file_name
              }}</a>
            </span>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import HtmlText from './HtmlText.vue';

export default {
  name: 'BusinessCaseSb',
  components: {
    HtmlText,
  },
  props: {
    business_case_id: { type: [String, Number], default: '' },
    background_color: { type: String, default: '#f8f8f8' },
    business_case_obj: { type: Object, default: {} },
    show_title: { type: Boolean, default: true },
  },
  computed: {
    ...mapState('report_list', ['lang']),
    ...mapGetters('report_list', ['selected_report']),
    ...mapGetters('story_board', ['selected_lv1']),
    mainColor() {
      const lv1Color = this.selected_lv1?.background_color;
      if (lv1Color && lv1Color !== '#014555') {
        return lv1Color;
      }
      return this.selected_report?.main_color || '#008C95';
    },
  },
  methods: {
    openImgPopup(e) {
      const img = e.target;
      if (img.tagName === 'IMG') {
        this.$EventBus.$emit('image-modal', img.getAttribute('src'), true);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
p {
  font-weight: 400;
  line-height: 1.6;
  margin-bottom: 0.5rem;
  letter-spacing: -0.01px;
  color: #111111;
}

.business-case-badge {
  font-size: 0.875rem;
  color: white;
  min-height: 30px;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  line-height: 0.9;
}
</style>
